import { usePortfolio } from 'contexts';
import React from 'react';
import { formatCount, formatPercent, formatUsd } from 'utils/number';
import { Currency, CurrencyBalance } from 'utils/types';

type Props = {
  source: string;
  balance: CurrencyBalance;
  balanceTotalUsd: number;
};
const PortfolioTableRow: React.FC<Props> = ({ source, balance, balanceTotalUsd }) => {
  const { netWorthBalanceTotalUsd } = usePortfolio();

  return (
    <tr className="border-b border-gray-e6e6e6 dark:border-gray-444">
      <td>{source}</td>
      <td className="py-2 text-right md:text-left">
        {(Object.keys(balance) as Array<Currency>).map((currency) => (
          <span key={currency} className="block">
            {formatCount(balance[currency]!, 2)} <span className="text-gray-999">{currency}</span>
          </span>
        ))}
      </td>
      <td className="text-right hidden md:table-cell">
        {formatPercent(balanceTotalUsd / netWorthBalanceTotalUsd)}
      </td>
      <td className="text-right hidden md:table-cell">{formatUsd(balanceTotalUsd)}</td>
    </tr>
  );
};

export default PortfolioTableRow;
